/* =========================================================
   David Halfon — custom.js (update-safe, modular)
   1) Price formatting (remove .00) — excludes cart/checkout
   2) GA4 INTERNAL traffic marker (dh_internal)
   3) Slideshow full-height “smart” (viewport - top bars)
   4) Header overlay trasparente (DESKTOP + HOME)
   ========================================================= */


/* =========================================================
   1) PRICE FORMATTING — remove trailing ,00 / .00
   ========================================================= */
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname.includes("/cart") || window.location.pathname.includes("/checkout")) return;

    const cleanPriceText = (text) => text.replace(/([.,]00)(?=$|\s|€)/g, "");

    const numberSelectors = [
      ".price-item--regular",
      ".price-item--sale",
      ".price-item--compare",
      ".price__regular .price-item",
      ".price__sale .price-item",
      ".card-information__price",
      ".product__price",
      ".price__compare-item",
    ];

    const updateAllPrices = () => {
      document.querySelectorAll(numberSelectors.join(",")).forEach((el) => {
        if (el.closest(".cart-drawer") || el.closest(".cart-items")) return;
        const originalHTML = el.innerHTML;
        const cleaned = originalHTML.replace(
          /(\d+[.,]\d{2})(?=$|\s|<\/|\&nbsp;|€)/g,
          (match) => cleanPriceText(match)
        );
        if (cleaned !== originalHTML) el.innerHTML = cleaned;
      });
    };

    updateAllPrices();
    const observer = new MutationObserver(() => updateAllPrices());
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();



/* =========================================================
   2) GA4 — INTERNAL traffic marker (update-safe)
   ========================================================= */
(function () {
  var KEY = "dh_internal";
  var TOKEN_ON = "/pages/internal-on-270521";
  var TOKEN_OFF = "/pages/internal-off-270521";
  var COOKIE_ON = "dh_internal=1; path=/; max-age=" + 60 * 60 * 24 * 365;

  function setFlag(on) {
    try {
      if (on) {
        localStorage.setItem(KEY, "1");
        document.cookie = COOKIE_ON;
      } else {
        localStorage.removeItem(KEY);
        document.cookie = "dh_internal=; path=/; max-age=0";
      }
    } catch (e) {}
  }

  function isInternal() {
    try {
      return localStorage.getItem(KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  try {
    var path = window.location.pathname || "";
    if (path === TOKEN_ON) setFlag(true);
    if (path === TOKEN_OFF) setFlag(false);
  } catch (e) {}

  function applyTrafficType(tries) {
    tries = tries || 0;
    if (!isInternal()) return;

    if (typeof window.gtag === "function") {
      window.gtag("set", { traffic_type: "internal" });
      window.gtag("config", "G-E4307231D3", { traffic_type: "internal" });
      return;
    }

    if (tries >= 80) return;
    setTimeout(function () {
      applyTrafficType(tries + 1);
    }, 100);
  }

  applyTrafficType();
})();



/* =========================================================
   3) Slideshow full-height “smart” (ENTERPRISE - hardened)
   Output CSS vars:
     --dh-ann-h
     --dh-header-h
     --dh-top-offset-normal  (ann + header)
     --dh-top-offset-overlay (ann only)
     --dh-top-offset         (compat = normal)
   Also:
     html.dh-home flag
   ========================================================= */
(function () {
  if (window.__dhHeroOffsetInit) return;
  window.__dhHeroOffsetInit = true;

  function isHome() {
    try {
      return (window.location && window.location.pathname === "/") ||
             (document.body && document.body.classList.contains("template-index"));
    } catch (e) {
      return false;
    }
  }

  function hasHomepageSlideshow() {
    try {
      return !!document.querySelector("#MainContent slideshow-component");
    } catch (e) {
      return false;
    }
  }

  function isVisible(el) {
    if (!el) return false;
    if (!(el instanceof Element)) return false;
    if (el.getClientRects && el.getClientRects().length === 0) return false;
    var style = window.getComputedStyle(el);
    return style.display !== "none" && style.visibility !== "hidden" && el.offsetHeight > 0;
  }

  function pickFirst(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function calcHeightsPx() {
    var announcementEl = pickFirst([
      "#shopify-section-announcement-bar",
      ".announcement-bar",
      ".utility-bar",
      ".announcement-bar-section",
    ]);

    var headerEl = pickFirst([
      "#shopify-section-header",
      ".header-wrapper",
      "sticky-header",
      "header.header",
      "header.section-header",
      ".section-header",
    ]);

    var annH = isVisible(announcementEl) ? announcementEl.offsetHeight : 0;
    var headH = isVisible(headerEl) ? headerEl.offsetHeight : 0;

    return {
      ann: annH,
      header: headH,
      normal: annH + headH,
      overlay: annH, // in overlay sottrai SOLO announcement
    };
  }

  function getViewportHeightPx() {
    try {
      if (window.visualViewport && typeof window.visualViewport.height === "number") {
        return Math.round(window.visualViewport.height);
      }
    } catch (e) {}
    return Math.round(window.innerHeight || 0);
  }

  function applyOffset() {
    if (!isHome()) return;

    // flag home sempre (il tuo body non ha template-index)
    document.documentElement.classList.add("dh-home");

    if (!hasHomepageSlideshow()) return;

    var h = calcHeightsPx();

    document.documentElement.style.setProperty("--dh-ann-h", h.ann + "px");
    document.documentElement.style.setProperty("--dh-header-h", h.header + "px");

    document.documentElement.style.setProperty("--dh-top-offset-normal", h.normal + "px");
    document.documentElement.style.setProperty("--dh-top-offset-overlay", h.overlay + "px");

    // compat (rimane normal)
    document.documentElement.style.setProperty("--dh-top-offset", h.normal + "px");

    var vv = getViewportHeightPx();
    document.documentElement.style.setProperty("--dh-vv-height", vv + "px");
  }

  var t = null;
  function applyOffsetDebounced() {
    if (t) clearTimeout(t);
    t = setTimeout(function () {
      applyOffset();
      t = null;
    }, 80);
  }

  function init() {
    applyOffset();

    window.addEventListener("resize", applyOffsetDebounced, { passive: true });
    window.addEventListener("orientationchange", applyOffsetDebounced, { passive: true });

    document.addEventListener("shopify:section:load", applyOffsetDebounced);
    document.addEventListener("shopify:section:reorder", applyOffsetDebounced);
    document.addEventListener("shopify:section:select", applyOffsetDebounced);

    try {
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", applyOffsetDebounced, { passive: true });
        window.visualViewport.addEventListener("scroll", applyOffsetDebounced, { passive: true });
      }
    } catch (e) {}

    try {
      var headerObsTarget = pickFirst([
        "#shopify-section-header",
        ".header-wrapper",
        "sticky-header",
        "header.header",
      ]);

      var annObsTarget = pickFirst([
        "#shopify-section-announcement-bar",
        ".announcement-bar",
        ".utility-bar",
      ]);

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () {
          applyOffsetDebounced();
        });
        if (headerObsTarget instanceof Element) ro.observe(headerObsTarget);
        if (annObsTarget instanceof Element) ro.observe(annObsTarget);
      }
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", function () {
    applyOffsetDebounced();
    setTimeout(applyOffsetDebounced, 150);
    setTimeout(applyOffsetDebounced, 450);
  });
})();



/* =========================================================
   4) Header overlay trasparente (DESKTOP + HOME)
   - Trasparente SOLO nella prima metà dello slideshow
   - HARDENED: aspetta che slideshow-component esista davvero
   ========================================================= */
(function () {
  if (window.__dhHeaderOverlayInit) return;
  window.__dhHeaderOverlayInit = true;

  var mql = window.matchMedia("(min-width: 750px)");
  var heroEl = null;
  var threshold = 0;
  var ticking = false;
  var mo = null;
  var ro = null;

  function isHome() {
    try {
      return (window.location && window.location.pathname === "/") ||
             (document.documentElement && document.documentElement.classList.contains("dh-home"));
    } catch (e) {
      return false;
    }
  }

  function shouldRun() {
    return mql.matches && isHome();
  }

  function findHero() {
    return document.querySelector("#MainContent slideshow-component");
  }

  function computeThresholdPx() {
    var h = 0;
    try {
      if (heroEl && heroEl.offsetHeight) h = heroEl.offsetHeight;
    } catch (e) {}

    if (!h || h < 200) {
      try { h = Math.round(window.innerHeight || 0); } catch (e2) { h = 0; }
    }
    return Math.round(h * 0.5);
  }

  function recalc() {
    heroEl = findHero();
    threshold = heroEl ? computeThresholdPx() : 0;

    // ResizeObserver sul hero per ricalcolare se Dawn cambia height (lazy media)
    try {
      if (ro) ro.disconnect();
      if (window.ResizeObserver && heroEl instanceof Element) {
        ro = new ResizeObserver(function () {
          threshold = computeThresholdPx();
          apply();
        });
        ro.observe(heroEl);
      }
    } catch (e) {}
  }

  function apply() {
    // sempre pulizia
    document.documentElement.classList.remove("dh-header-overlay");

    if (!shouldRun()) return;
    if (!heroEl || threshold <= 0) return;

    var y = window.scrollY || window.pageYOffset || 0;
    if (y < threshold) document.documentElement.classList.add("dh-header-overlay");
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      apply();
    });
  }

  function ensureHeroThenRun() {
    recalc();
    apply();

    if (heroEl) {
      if (mo) { try { mo.disconnect(); } catch (e) {} }
      mo = null;
      return;
    }

    // aspetta che Dawn inserisca/idrati slideshow-component
    try {
      if (mo) mo.disconnect();
      mo = new MutationObserver(function () {
        var h = findHero();
        if (h) {
          heroEl = h;
          threshold = computeThresholdPx();
          apply();
          try { mo.disconnect(); } catch (e) {}
          mo = null;
        }
      });

      var target = document.querySelector("#MainContent") || document.body;
      mo.observe(target, { childList: true, subtree: true });
    } catch (e) {}
  }

  function init() {
    ensureHeroThenRun();

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () {
      ensureHeroThenRun();
    }, { passive: true });

    document.addEventListener("shopify:section:load", function () {
      ensureHeroThenRun();
      setTimeout(ensureHeroThenRun, 150);
      setTimeout(ensureHeroThenRun, 450);
    });

    window.addEventListener("load", function () {
      ensureHeroThenRun();
      setTimeout(ensureHeroThenRun, 150);
      setTimeout(ensureHeroThenRun, 450);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  if (mql.addEventListener) {
    mql.addEventListener("change", function () {
      ensureHeroThenRun();
    });
  } else if (mql.addListener) {
    mql.addListener(function () {
      ensureHeroThenRun();
    });
  }
})();



(function () {
  const MOBILE_MAX = 749;

  function isMobile() {
    return window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;
  }

  function initFooterAccordions() {
    const footer = document.querySelector('footer.footer, .footer');
    if (!footer) return;

    // Dawn: blocchi del footer spesso sono .footer-block
    const blocks = footer.querySelectorAll('.footer-block');
    if (!blocks.length) return;

    blocks.forEach((block, idx) => {
      // evita doppia inizializzazione
      if (block.dataset.dhAccInit === '1') return;

      // heading tipico Dawn: .footer-block__heading
      const heading = block.querySelector('.footer-block__heading');
      // lista link tipica: ul dentro .footer-block__details-content oppure direttamente ul
      const content =
        block.querySelector('.footer-block__details-content') ||
        block.querySelector('ul');

      if (!heading || !content) return;

      // Se dentro al blocco c’è un form newsletter o altro, saltalo (tu vuoi solo le 3 sezioni menu)
      // Regola: deve contenere una UL con link
      if (!content.querySelector('a')) return;

      block.dataset.dhAccInit = '1';

      // Wrapper accordion (per bordo sopra)
      block.classList.add('dh-footer-acc__wrap');

      // Crea bottone
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dh-footer-acc__btn';
      btn.setAttribute('aria-expanded', isMobile() ? 'false' : 'true');

      const titleSpan = document.createElement('span');
      titleSpan.className = 'dh-footer-acc__title';
      titleSpan.textContent = heading.textContent.trim();

      const chev = document.createElement('span');
      chev.className = 'dh-footer-acc__chev';
      chev.setAttribute('aria-hidden', 'true');

      btn.appendChild(titleSpan);
      btn.appendChild(chev);

      // Panel
      const panel = document.createElement('div');
      panel.className = 'dh-footer-acc__panel';
      const panelId = `dh-footer-panel-${idx}-${Math.random().toString(16).slice(2)}`;
      panel.id = panelId;
      btn.setAttribute('aria-controls', panelId);

      // Sposta il contenuto nel panel
      panel.appendChild(content);

      // Nascondi heading originale
      heading.style.display = 'none';

      // Inserisci bottone + panel (prima del resto)
      // NB: content è già stato spostato nel panel
      block.insertBefore(btn, block.firstChild);
      block.insertBefore(panel, btn.nextSibling);

      // Stato iniziale
      function applyState() {
        const mobile = isMobile();
        if (mobile) {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          panel.style.display = expanded ? 'block' : 'none';
        } else {
          btn.setAttribute('aria-expanded', 'true');
          panel.style.display = 'block';
        }
      }

      applyState();

      // Toggle mobile
      btn.addEventListener('click', () => {
        if (!isMobile()) return;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        panel.style.display = expanded ? 'none' : 'block';
      });

      // Re-apply su resize
      window.addEventListener('resize', () => applyState());
    });
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordions);
  } else {
    initFooterAccordions();
  }
})();




/* ==================================================
  DH — Newsletter popup triggers (clean, scoped)
  - Footer: tap/click input => opens popup (NO keyboard on mobile)
  - Announcement: link #dh-newsletter => opens popup
  - Footer submit: hard block => opens popup (safe)
================================================== */
(function () {
  if (window.__DH_NL_TRIGGERS_INIT__) return;
  window.__DH_NL_TRIGGERS_INIT__ = true;

  function openNL(originEl) {
    const modalEl = document.getElementById("dh-newsletter-modal");
    if (modalEl && !modalEl.hasAttribute("hidden")) return;

    const tryOpen = () => {
      const openFn = window.DHNewsletterModal && window.DHNewsletterModal.open;
      if (typeof openFn === "function") {
        openFn({ originEl });
        return true;
      }
      return false;
    };

    // prova subito
    if (tryOpen()) return;

    // fallback robusto: aspetta fino a ~3.5s (70 * 50ms)
    let tries = 0;
    const t = setInterval(() => {
      tries += 1;
      if (tryOpen() || tries >= 70) clearInterval(t);
    }, 50);
  }

  function isFooterNewsletterEmailInput(el) {
    if (!el || !el.closest) return false;
    if (!el.closest(".footer")) return false;

    return (
      el.matches('.newsletter-form input[type="email"]') ||
      el.matches('.newsletter-form input[name="contact[email]"]')
    );
  }

  /* -----------------------------
     Footer: intercetta PRIMA del focus (fix tastiera mobile)
     NB: usiamo capture=true per “battere” Dawn e Safari/Chrome
  ----------------------------- */
  document.addEventListener(
    "pointerdown",
    function (e) {
      const el = e.target;
      if (!isFooterNewsletterEmailInput(el)) return;

      // blocca focus nativo => niente tastiera
      e.preventDefault();
      e.stopPropagation();
      openNL(el);
    },
    true
  );

  // Desktop: Enter nell'input => popup (no submit footer)
  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key !== "Enter") return;
      const el = e.target;
      if (!isFooterNewsletterEmailInput(el)) return;

      e.preventDefault();
      e.stopPropagation();
      openNL(el);
    },
    true
  );

  /* -----------------------------
     Announcement: SOLO link dedicato
  ----------------------------- */
  document.addEventListener(
    "click",
    function (e) {
      const a = e.target && e.target.closest('a[href="#dh-newsletter"]');
      if (!a) return;

      e.preventDefault();
      e.stopPropagation();
      openNL(a);
    },
    true
  );

  /* -----------------------------
     Footer: blocca submit e usa solo popup (SAFE)
     (lasciato perché tu avevi già il submit nascosto, ma così eviti submit accidentali)
  ----------------------------- */
  if (!window.__DH_NL_FOOTER_BLOCK_INIT__) {
    window.__DH_NL_FOOTER_BLOCK_INIT__ = true;

    document.addEventListener(
      "submit",
      function (e) {
        const form = e.target;
        if (!form || !form.closest) return;

        // Solo nel footer
        if (!form.closest(".footer")) return;

        // Solo form con email (newsletter)
        const email = form.querySelector(
          '.newsletter-form input[type="email"], .newsletter-form input[name="contact[email]"], input[type="email"], input[name="contact[email]"]'
        );
        if (!email) return;

        e.preventDefault();
        e.stopPropagation();
        openNL(email);
      },
      true
    );
  }
})();







(function () {
  function openRestaConnessoMobile() {
    // solo mobile
    if (window.innerWidth > 749) return;

    // trova il bottone "RESTA CONNESSO"
    const btns = document.querySelectorAll('.dh-footer-acc__btn');
    let targetBtn = null;

    btns.forEach((btn) => {
      const title = btn.querySelector('.dh-footer-acc__title');
      if (!title) return;
      
      const txt = title.textContent.trim().toUpperCase();
if (txt === 'RESTA CONNESSO' || txt === 'CONNECT') targetBtn = btn;
    });

    if (!targetBtn) return;

    // trova il panel dal suo aria-controls (più affidabile)
    const panelId = targetBtn.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    // forza stato "aperto" in modo coerente
    targetBtn.setAttribute('aria-expanded', 'true');
    panel.style.display = 'block';
    panel.hidden = false;

    // se esiste un inline style che lo "resetta", lo sovrascriviamo
    // (alcuni script mettono display:none dopo)
  }

  // 1) dopo che la pagina ha caricato TUTTI gli script
  window.addEventListener('load', function () {
    openRestaConnessoMobile();

    // 2) e di nuovo subito dopo (copre il caso in cui un JS lo resetta dopo load)
    setTimeout(openRestaConnessoMobile, 150);
    setTimeout(openRestaConnessoMobile, 400);
  });
})();








/* =========================================================
   5) Collection cards — Make product IMAGE clickable
   (NO Liquid edits, update-safe, works desktop+mobile)
   - Click on media area opens the same product link as title
   - Does NOT hijack clicks on swatches / quick add / buttons / links
   ========================================================= */
(function () {
  if (window.__DH_CARD_MEDIA_CLICK_INIT__) return;
  window.__DH_CARD_MEDIA_CLICK_INIT__ = true;

  function shouldIgnorePage() {
    try {
      // Nel Theme Editor lascia a Shopify la gestione della navigazione
      // dell'anteprima, così editor e template selezionato restano sincronizzati.
      if (window.Shopify && window.Shopify.designMode) return true;

      var p = window.location.pathname || "";
      return p.includes("/cart") || p.includes("/checkout");
    } catch (e) {
      return false;
    }
  }

  // area immagine (Dawn)
  var CARD = ".product-card-wrapper";
  var MEDIA = ".card__media, .card__inner"; // robust: alcune varianti Dawn cliccano dentro inner

  // link prodotto già presente (titolo)
  var LINK =
    'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"], .card__heading a.full-unstyled-link';

  // elementi interattivi da NON intercettare
  var EXCLUDE = [
    "a",
    "button",
    "input",
    "label",
    "select",
    "textarea",
    "summary",
    "[role='button']",
    ".quick-add",
    ".quick-add__submit",
    "product-form",
    "variant-selects",
    ".color-swatch-list",
    ".swatch-color",
    ".card__badge",
    ".shopify-product-form",
  ].join(",");

  function onClick(e) {
    var t = e.target;

    // se clicchi su elementi interattivi, non fare nulla
    if (t && t.closest && t.closest(EXCLUDE)) return;

    // deve essere dentro una card
    var card = t.closest ? t.closest(CARD) : null;
    if (!card) return;

    // deve essere dentro la zona media/immagine
    var mediaArea = t.closest ? t.closest(MEDIA) : null;
    if (!mediaArea || !card.contains(mediaArea)) return;

    // prende il link prodotto (quello del titolo)
    var link = card.querySelector(LINK);
    if (!link || !link.href) return;

    // evita navigazione se l’utente sta selezionando testo
    try {
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length) return;
    } catch (e2) {}

    window.location.href = link.href;
  }

  function init() {
    if (shouldIgnorePage()) return;

    // click delegato (funziona anche con infinite scroll / lazy render)
    document.addEventListener("click", onClick, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();













/* =========================================================
   DH — Klarna OSM (PDP) — style override injected LAST
   - Removes white box
   - Smaller text
   - Closer to ATC button
   - Left aligned (RL-like)
   ========================================================= */
(function () {
  if (window.__DH_KLARNA_OSM_STYLE__) return;
  window.__DH_KLARNA_OSM_STYLE__ = true;

  var STYLE_ID = "dh-klarna-osm-style";

function css() {
  return `
/* =========================================================
   DH — Klarna OSM (PDP) — rem-based + full spacing control
   ========================================================= */

/* WRAPPER — vertical spacing control */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]{
  display:block;
  margin-top: var(--dh-klarna-mt, 0.375rem) !important;
  margin-bottom: var(--dh-klarna-mb, 0rem) !important;
}

/* CONTAINER — remove box + RL layout */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]::part(osm-container){
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  padding: 0 !important;

  display:flex !important;
  flex-direction: row !important;
  justify-content:flex-start !important;
  align-items:center !important;
  gap: var(--dh-klarna-gap, 0.375rem) !important;

  text-align:left !important;
  font-size: var(--dh-klarna-font, 0.625rem) !important;
  line-height: var(--dh-klarna-lh, 0.875rem) !important;
  color: var(--dh-klarna-color, #333333) !important;
}

/* MESSAGE */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]::part(osm-message){
  margin:0 !important;
}

/* CTA */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]::part(osm-cta){
  background:none !important;
  border:0 !important;
  padding:0 !important;
  margin:0 !important;
  font:inherit !important;
  line-height:inherit !important;
  text-decoration: var(--dh-klarna-cta-decoration, underline) !important;
  text-underline-offset: var(--dh-klarna-underline-offset, 0.12em) !important;
  cursor:pointer !important;
}

/* LOGO */
klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]::part(osm-logo){
  font-size: var(--dh-klarna-logo-font, 0.6875rem) !important;
  line-height:inherit !important;
}
`;
}

  function inject() {
    try {
      var old = document.getElementById(STYLE_ID);
      if (old) old.remove();

      var s = document.createElement("style");
      s.id = STYLE_ID;
      s.textContent = css();
      document.head.appendChild(s);
    } catch (e) {}
  }

  function hasPlacement() {
    try {
      return !!document.querySelector(
        'klarna-placement[data-key="credit-promotion-auto-size"][data-theme="custom"]'
      );
    } catch (e) {
      return false;
    }
  }

  function init() {
    // Inject subito e poi ancora quando Klarna monta
    inject();

    var tries = 0;
    var t = setInterval(function () {
      tries += 1;
      if (hasPlacement()) {
        inject(); // reinietta "last" quando il blocco esiste
        clearInterval(t);
      }
      if (tries >= 80) clearInterval(t); // ~4s
    }, 50);

    // Se Klarna re-renderizza, reiniettiamo
    try {
      var mo = new MutationObserver(function () {
        if (hasPlacement()) inject();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", function () {
    inject();
    setTimeout(inject, 150);
    setTimeout(inject, 450);
  });
})();







/* DH — Shipping note: add class to IT/EN/ES text block */
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('p.product__text.inline-richtext')
    .forEach((el) => {
      const t = el.textContent.trim().toLowerCase();

      const isIt = t.includes('consegna') && t.includes('gratuita') && t.includes('€');
      const isEn = t.includes('free') && t.includes('standard') && t.includes('€');
      const isEs = t.includes('envío') && t.includes('estándar') && t.includes('gratuito') && t.includes('€');

      if (isIt || isEn || isEs) el.classList.add('dh-shipping-note');
    });
});



/* =========================================================
   DH — load custom-menu.js from the same Shopify asset folder
   Mantiene la logica del menu separata dai moduli esistenti.
   ========================================================= */
(function () {
  "use strict";

  if (window.__dhCustomMenuLoaderStarted) return;
  window.__dhCustomMenuLoaderStarted = true;

  var currentSource = document.currentScript && document.currentScript.src;

  if (!currentSource) {
    var customScript = Array.prototype.find.call(document.scripts, function (script) {
      return /\/assets\/custom\.js(?:\?|$)/.test(script.src || "");
    });
    currentSource = customScript && customScript.src;
  }

  if (!currentSource) {
    console.warn("DH menu: impossibile individuare la cartella degli asset custom.");
    return;
  }

  var currentUrl = new URL(currentSource);
  var menuSource = new URL("custom-menu.js", currentUrl);
  /* Riusa la versione di custom.js come cache-buster. I due file vengono
     consegnati insieme, quindi ogni aggiornamento forza anche il menu. */
  menuSource.search = currentUrl.search;
  menuSource.hash = "";

  if (document.querySelector('script[data-dh-custom-menu-loader="true"]')) return;

  var script = document.createElement("script");
  script.src = menuSource.href;
  script.async = false;
  script.setAttribute("data-dh-custom-menu-loader", "true");
  document.head.appendChild(script);
})();
